var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Type } from 'class-transformer';
import { Column, CreateDateColumn, Entity, Index, OneToMany, PrimaryColumn, UpdateDateColumn } from 'typeorm';
let Project = class Project {
    id;
    createdDate;
    updatedDate;
    name;
    description;
    enabled;
    tags;
    tests;
    assets;
    roots;
    domains;
    deployments;
    dependencies;
};
__decorate([
    PrimaryColumn('uuid', { default: () => 'uuidv7()' }),
    __metadata("design:type", String)
], Project.prototype, "id", void 0);
__decorate([
    Index(),
    CreateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Project.prototype, "createdDate", void 0);
__decorate([
    UpdateDateColumn({ type: 'timestamptz' }),
    Type(() => Date),
    __metadata("design:type", Date)
], Project.prototype, "updatedDate", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Project.prototype, "name", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], Project.prototype, "description", void 0);
__decorate([
    Column({ default: true }),
    __metadata("design:type", Boolean)
], Project.prototype, "enabled", void 0);
__decorate([
    Column('text', { array: true, default: () => 'ARRAY[]::text[]' }),
    __metadata("design:type", Array)
], Project.prototype, "tags", void 0);
__decorate([
    OneToMany('Test', (test) => test.project, { cascade: true }),
    __metadata("design:type", Array)
], Project.prototype, "tests", void 0);
__decorate([
    OneToMany('Asset', (asset) => asset.project, { cascade: true }),
    __metadata("design:type", Array)
], Project.prototype, "assets", void 0);
__decorate([
    OneToMany('Root', (root) => root.project, { cascade: true }),
    __metadata("design:type", Array)
], Project.prototype, "roots", void 0);
__decorate([
    OneToMany('Domain', (domain) => domain.project, { cascade: true }),
    __metadata("design:type", Array)
], Project.prototype, "domains", void 0);
__decorate([
    OneToMany('Deployment', (deployment) => deployment.project, { cascade: true }),
    __metadata("design:type", Array)
], Project.prototype, "deployments", void 0);
__decorate([
    OneToMany('Dependency', (dependency) => dependency.project, { cascade: true }),
    __metadata("design:type", Array)
], Project.prototype, "dependencies", void 0);
Project = __decorate([
    Entity()
], Project);
export { Project };
//# sourceMappingURL=data:application/json;base64,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